import { createFileRoute, Outlet } from "@tanstack/react-router";

function WorkflowsLayout() {
  return (
    <div className="h-full overflow-y-auto">
      <div className="mx-auto min-w-0 max-w-4xl px-4 py-6 sm:px-6 sm:py-8 min-[80rem]:px-8 min-[80rem]:py-12">
        <div className="space-y-6">
          <header className="space-y-2">
            <h1 className="text-headline text-foreground">Automations</h1>
            <p className="text-body text-muted-foreground">Proactive research LATO delivers</p>
          </header>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/_auth/_agents/briefings")({
  component: WorkflowsLayout,
});
